/**
 * Shared color palette for medical/insurance code chip categories.
 *
 * Consumed by:
 *   - EditableCodeChipSection (endorsement forms)
 *   - AutocompleteCodeInput   (ref-code typeahead inputs)
 *
 * Keep this the single source of truth — do not duplicate these values in
 * other components. If a new code category needs a chip color, add it here.
 */

export interface CodeChipPalette {
  bg: string;
  color: string;
}

export const CODE_CHIP_COLORS: Record<string, CodeChipPalette> = {
  icd: { bg: "#eff6ff", color: "#1e40af" },
  cpt: { bg: "#f0fdf4", color: "#166534" },
  ndc: { bg: "#fdf4ff", color: "#6b21a8" },
  pos: { bg: "#fff7ed", color: "#9a3412" },
  country: { bg: "#f0f9ff", color: "#075985" },
  facility: { bg: "#fef2f2", color: "#991b1b" },
  claim: { bg: "#f5f3ff", color: "#5b21b6" },
  trigger: { bg: "#fef3c7", color: "#92400e" },
  phase: { bg: "#ecfdf5", color: "#065f46" },
};

/** Resolve a palette, falling back to the ICD palette if the key is unknown. */
export const resolveCodeChipPalette = (color: string): CodeChipPalette =>
  CODE_CHIP_COLORS[color] || CODE_CHIP_COLORS.icd;
